"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@mui/utils");
const boxClasses = (0, _utils.unstable_generateUtilityClasses)('MuiBox', ['root']);
var _default = exports.default = boxClasses;